export enum AccountSections {
  AccountDetails = 0,
  MyAddress = 1,
  // TODO these are commented out as they are not ready for MVP
  // MyDocuments = 2,
  Notifications = 2,
  wallet = 3,
  // Settings = 4,
}
